import { fetch as fetchApi, isString } from "./api";

import { Emv, EmvCodec } from "../store/emv/types";
import { flattenData, withDecoded } from "./index";

function mapToModel(data: object): Emv {
  return withDecoded(EmvCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(id: string | null | undefined, params?: {}): Promise<Emv> {
  return fetchApi({
    nestedResourcePath: ["emv"],
    id,
    params
  })
    .then(response => {
      return isString(response.data) ? JSON.parse(response.data) : response.data;
    })
    .then(data => mapToModel(flattenData(data)));
}
